import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppNavigate from '../../components/reusable/app-navigate/AppNavigate';
import { Paths } from '../../shared/paths';
import CurrentTraining from './current-training/CurrentTraining';
import FinishedTraining from './finished-training/FinishedTraining';
import { FinishingTraining } from './finishing-training/FinishingTraining';
import GenerateTraining from './generate-training/GenerateTraining';
import NewTraining from './new-training/NewTraining';
import StartNewTraining from './start-new-training/StartNewTraining';
import Training from './training/Training';
import Trainings from './trainings/Trainings';

export default function TrainingsRouter() {
  return (
    <Routes>
      <Route path={`${Paths.trainings.list}/*`} element={<Trainings />} />
      <Route path={`${Paths.trainings.new}`} element={<NewTraining />} />
      <Route
        path={`${Paths.trainings.startNew}`}
        element={<StartNewTraining />}
      />
      <Route path={Paths.trainings.generate} element={<GenerateTraining />} />
      <Route path=":trainingId/finishing" element={<FinishingTraining />} />
      <Route path=":trainingId/current" element={<CurrentTraining />} />
      <Route
        path={`${Paths.trainings.finished}/:trainingId/*`}
        element={<FinishedTraining />}
      />
      <Route path={`/:trainingId/*`} element={<Training />} />
      <Route
        path={'*'}
        element={<AppNavigate to={Paths.trainings.toList} replace />}
      />
    </Routes>
  );
}
